"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _westfieldLogoInline = _interopRequireDefault(require("../../images/westfield-logo.inline.svg"));

var _directDigitalLogoInline = _interopRequireDefault(require("../../images/direct-digital-logo.inline.svg"));

var _directMarketingLogoInline = _interopRequireDefault(require("../../images/direct-marketing-logo.inline.svg"));

var _westfieldPlusInline = _interopRequireDefault(require("../../images/westfield-plus.inline.svg"));

var _classnames = _interopRequireDefault(require("classnames"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _excluded = ["className", "type"];

var LogoWithoutLink = function LogoWithoutLink(_ref) {
  var className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  switch (type) {
    case 'direct-digital':
    case 'direct-digital-mono':
      return /*#__PURE__*/_react.default.createElement(_directDigitalLogoInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type])
      }));

    case 'direct-marketing':
    case 'direct-marketing-mono':
      return /*#__PURE__*/_react.default.createElement(_directMarketingLogoInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type])
      }));

    case 'westfield-plus':
      return /*#__PURE__*/_react.default.createElement(_westfieldPlusInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type])
      }));

    default:
      return /*#__PURE__*/_react.default.createElement(_westfieldLogoInline.default, (0, _extends2.default)({}, props, {
        className: (0, _classnames.default)(className, _indexModule.default[type])
      }));
  }
};

LogoWithoutLink.propTypes = {
  className: _propTypes.default.string,
  type: _propTypes.default.oneOf(['default', 'alt', 'direct-digital', 'direct-digital-mono', 'direct-marketing', 'direct-marketing-mono', 'westfield-plus'])
};
var _default = LogoWithoutLink;
exports.default = _default;